import { AttachMoney, CalendarToday, Description } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import { Surplus } from 'lib/api/reports/types';
import { formatDate, formatMoney } from 'lib/functions/utils';
import React from 'react';

import InfoRow from './InfoRow';

interface SurplusReleasedSectionProps {
  surplus: Surplus;
}

const SurplusReleasedSection: React.FC<SurplusReleasedSectionProps> = ({
  surplus,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(76, 175, 80, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(76, 175, 80, 0.15)',
          mt: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'success.main',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Excedente Liberado
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InfoRow
            label="Folio"
            value={
              surplus.surplusDocumentFolio ? surplus.surplusDocumentFolio : null
            }
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'success.main' }} />
            }
          />
          <InfoRow
            label="Monto Liberado"
            value={
              surplus.surplusDocumentAmount
                ? formatMoney(surplus.surplusDocumentAmount)
                : null
            }
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'success.main' }} />
            }
          />
          <InfoRow
            label="Fecha Liberación"
            value={
              surplus.surplusCreatedAt
                ? formatDate(new Date(surplus.surplusCreatedAt))
                : null
            }
            maxLength={40}
            icon={
              <CalendarToday
                sx={{ fontSize: '0.8rem', color: 'success.main' }}
              />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SurplusReleasedSection;
